const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20visual%20representing%20a%20popular%20Chinese%20drama%20series%20with%20soft%20coral%20and%20amber%20abstract%20elements%2C%20modern%20streaming%20platform%20aesthetic%2C%20elegant%20composition%2C%20warm%20atmosphere&width=800&height=500&seq=media-01&orientation=landscape',
    alt: '热播剧集精彩预告',
    tag: '热播中',
    title: '《长安十二时辰》精彩片段',
    desc: '古装悬疑巨制，雷佳音、易烊千玺主演，每一帧都是电影级画面，豆瓣高分推荐。',
    stat: '12.6万次播放',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20cinematic%20visual%20for%20a%20comedy%20show%20with%20playful%20coral%20and%20amber%20shapes%2C%20modern%20design%2C%20light%20atmosphere%2C%20entertainment%20aesthetic&width=800&height=500&seq=media-02&orientation=landscape',
    alt: '综艺节目爆笑集锦',
    tag: '综艺',
    title: '《一年一度喜剧大赛》爆笑合集',
    desc: '年度最欢乐综艺节目，各路喜剧人齐聚，笑点密集全程高能，适合解压放松。',
    stat: '8.3万次播放',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20abstract%20documentary%20style%20visual%20with%20coral%20and%20amber%20geometric%20shapes%2C%20elegant%20minimalist%20design%2C%20nature%20motif%2C%20soft%20atmosphere&width=800&height=500&seq=media-03&orientation=landscape',
    alt: '高分纪录片推荐',
    tag: '纪录片',
    title: 'BBC高分自然纪录片精选',
    desc: '震撼视觉的自然纪录大片，从极地到深海，从草原到雨林，感受地球之美。',
    stat: '6.8万次播放',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20abstract%20animation%20style%20visual%20with%20soft%20coral%20and%20amber%20playful%20shapes%2C%20modern%20design%2C%20creative%20atmosphere%2C%20family%20entertainment%20aesthetic&width=800&height=500&seq=media-04&orientation=landscape',
    alt: '动画电影专区',
    tag: '动画',
    title: '亲子必看动画电影合集',
    desc: '精选国内外优质动画电影，画面精美故事温暖，适合全家一起观看的周末好选择。',
    stat: '5.1万次播放',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20abstract%20K-drama%20style%20visual%20with%20elegant%20coral%20and%20amber%20geometric%20shapes%2C%20modern%20Korean%20aesthetic%2C%20romantic%20atmosphere%2C%20soft%20lighting&width=800&height=500&seq=media-05&orientation=landscape',
    alt: '韩剧热播推荐',
    tag: '韩剧',
    title: '2025上半年口碑韩剧盘点',
    desc: '从浪漫爱情到悬疑犯罪，从职场到奇幻，盘点今年最值得追的韩剧佳作。',
    stat: '9.7万次播放',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            精彩片段
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门影视精彩内容，点击即刻在线观看
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative overflow-hidden h-52">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/30">
                  <div className="w-16 h-16 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-secondary-500/90 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 font-serif">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.stat}
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    在线观看
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}